import { Alert, SpaceBetween } from "@amzn/awsui-components-react";
import * as React from "react";
import { ContentEvaluationModel } from "../../model/content-evaluation-model";
import { ResultsSummary } from "../content-evaluation/ResultsSummary";
import { FindingsList } from "../content-evaluation/FindingsList";

export const ContentEvaluationResults = (props: ContentEvaluationModel.ContentEvaluationResultsProps) => {
    const { results } = props;

    return (
        <Alert
            statusIconAriaLabel={results.totalFindings > 0 ? "Warning" : "Success"}
            type={results.totalFindings > 0 ? "warning" : "success"}
        >
            <SpaceBetween size="m">
                <ResultsSummary
                    totalFindings={results.totalFindings}
                    findings={results.findings}
                />
                <FindingsList findings={results.findings} />
            </SpaceBetween>
        </Alert>
    );
};
